(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hh-bundle-js"] && !Shopify.designMode) return;
  try {
    (function(){
  // ---------------------------------------------------------------------------
  // PDP bundle behaviour. Rewritten 6 Sep 2026.
  //
  // Percentages come from snippets/hh-ladder.liquid (window.HH_LADDER), shared
  // with the homepage bundle so the two cards cannot drift apart - which is the
  // bug this replaced: the card quoted $223 on a cart that charged $228.
  //
  // There is no bundle app in the path any more. Fly Bundles' _flyBundles:*
  // line properties discount nothing now that Grip-X is out of its offer
  // (verified with real carts), so lines are added plain and Shopify's native
  // automatic discounts apply off quantity alone.
  // ---------------------------------------------------------------------------
  var P = window.HH_PRICE;
  if (!P) return;

  // Saved before any app script can patch it, so our add reaches the cart intact.
  var nativeFetch = window.fetch && window.fetch.bind(window);

  // Nudge third-party cart-drawer widgets to re-render against the drawer we
  // just rebuilt. Guarded, so it is a harmless no-op when no such app is on the
  // page.
  function syncCartWidgets(){
    try { window.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
  }

  Array.prototype.slice.call(document.querySelectorAll('.hhb [data-b1]')).forEach(function(b1){
    var stdHandle  = b1.getAttribute('data-b1-std-handle') || '';
    var gripHandle = b1.getAttribute('data-b1-grip-handle') || '';
    var stdSel  = b1.querySelector('[data-b1-std]');
    var gripSel = b1.querySelector('[data-b1-grip]');
    var nowEl   = b1.querySelector('[data-b1-now]');
    var wasEl   = b1.querySelector('[data-b1-was]');
    var saveEl  = b1.querySelector('[data-b1-save]');
    var addBtn  = b1.querySelector('[data-b1-add]');
    var tiers   = Array.prototype.slice.call(b1.querySelectorAll('[data-b1-tier]'));
    if (!stdSel || !gripSel || !tiers.length) return;

    // data-price is money_without_currency, e.g. "34.97" -> 3497 cents
    function priceOf(sel){
      if (!sel || !sel.options.length) return 0;
      var v = parseFloat(sel.options[sel.selectedIndex].getAttribute('data-price')) || 0;
      return Math.round(v * 100);
    }
    function totals(n){
      var sp = priceOf(stdSel), gp = priceOf(gripSel);
      return {
        base: (sp + gp) * n,
        disc: P.unitAfter(sp, P.pctFor(stdHandle, n)) * n + P.unitAfter(gp, P.pctFor(gripHandle, n)) * n
      };
    }
    function qtyOf(t){ return parseInt(t.getAttribute('data-qty'), 10) || 1; }
    function selectedTier(){
      for (var i = 0; i < tiers.length; i++) {
        var r = tiers[i].querySelector('.b1-tier-input');
        if (r && r.checked) return tiers[i];
      }
      return tiers[0];
    }
    function pct(tt){ return (tt.base > 0) ? Math.round((1 - tt.disc / tt.base) * 100) : 0; }

    function recalc(){
      tiers.forEach(function(t){
        var tt = totals(qtyOf(t)), p = pct(tt), saved = tt.base - tt.disc;
        var pe = t.querySelector('[data-b1-tier-price]'),
            se = t.querySelector('[data-b1-tier-save]'),
            oe = t.querySelector('[data-b1-tier-off]');
        if (pe) pe.textContent = P.money(tt.disc);
        if (se) se.textContent = saved > 0 ? 'Save ' + P.money(saved) : '';
        if (oe) { oe.textContent = p > 0 ? p + '% OFF' : ''; oe.style.display = p > 0 ? '' : 'none'; }
        var r = t.querySelector('.b1-tier-input');
        t.classList.toggle('is-selected', !!(r && r.checked));
      });
      var sel = selectedTier(), t = totals(qtyOf(sel)), p = pct(t), saved = t.base - t.disc;
      if (nowEl) nowEl.textContent = P.money(t.disc);
      if (saved > 0) {
        if (wasEl) wasEl.textContent = P.money(t.base);
        if (saveEl) saveEl.textContent = 'You save ' + P.money(saved) + ' (' + p + '%)';
      } else {
        if (wasEl) wasEl.textContent = '';
        if (saveEl) saveEl.textContent = '';
      }
    }

    stdSel.addEventListener('change', recalc);
    gripSel.addEventListener('change', recalc);
    tiers.forEach(function(t){
      var r = t.querySelector('.b1-tier-input');
      if (r) r.addEventListener('change', recalc);
    });
    recalc();

    if (addBtn) {
      addBtn.addEventListener('click', function(){
        if (!stdSel.value || !gripSel.value) return;
        var qty = qtyOf(selectedTier());
        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        var items = [
          { id: parseInt(stdSel.value, 10),  quantity: qty },
          { id: parseInt(gripSel.value, 10), quantity: qty }
        ];
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var sectionIds = (cart && typeof cart.getSectionsToRender === 'function')
          ? cart.getSectionsToRender().map(function(s){ return s.id; })
          : ['cart-drawer', 'cart-icon-bubble'];
        var payload = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          payload.sections = sectionIds;
          payload.sections_url = window.location.pathname;
        }
        var doFetch = nativeFetch || window.fetch;

        // Fallback: pull the drawer straight from the Section Rendering API when
        // the add response came back without usable section HTML, so the item
        // list never renders blank.
        function renderFromSections(){
          return doFetch(window.location.pathname + '?sections=' + sectionIds.join(','))
            .then(function(r){ return r.json(); })
            .then(function(sec){
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents({ sections: sec });
              syncCartWidgets();
            });
        }

        doFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify(payload)
        })
        .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(data){
          addBtn.disabled = false; addBtn.textContent = label;
          if (cart && typeof cart.renderContents === 'function') {
            // Dawn renders `is-empty` on <cart-drawer> itself when the page loads
            // with an empty cart, and renderContents() only clears it from
            // .drawer__inner. Leave it and the drawer opens looking broken.
            if (cart.classList.contains('is-empty')) { cart.classList.remove('is-empty'); }
            cart.renderContents(data);
            syncCartWidgets();
            requestAnimationFrame(syncCartWidgets);
            setTimeout(syncCartWidgets, 600);
            setTimeout(function(){
              var hasItems = cart.querySelector('.cart-item, [id^="CartDrawer-Item"]');
              if (!hasItems) { renderFromSections().catch(function(){}); }
              else { syncCartWidgets(); }
            }, 150);
          }
          else { window.location.href = '/cart'; }
        })
        .catch(function(){
          addBtn.disabled = false; addBtn.textContent = label;
          alert('Something went wrong adding to cart, please try again.');
        });
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hh-home-js"] && !Shopify.designMode) return;
  try {
    (function(){
 var root=document;
 function q(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));}
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
 q('.hh-home .reveal, .hh-home .reveal-scale').forEach(function(el){io.observe(el);});
 q('.hh-home .hero').forEach(function(h){requestAnimationFrame(function(){setTimeout(function(){h.classList.add('loaded');},60);});});
 q('.hh-home [data-stagger]').forEach(function(w){var step=parseFloat(w.dataset.stagger)||0.08;Array.prototype.slice.call(w.children).forEach(function(c,i){c.style.setProperty('--d',(i*step).toFixed(2)+'s');});});
 q('.hh-home .marquee-track').forEach(function(t){t.innerHTML+=t.innerHTML;});
 // reviews arrows
 var scr=root.getElementById('testiScroller');
 if(scr){
  var step=function(){var c=scr.querySelector('.testi-card');return c?c.getBoundingClientRect().width+16:320;};
  var p=root.getElementById('testiPrev'),n=root.getElementById('testiNext');
  if(p)p.addEventListener('click',function(){scr.scrollBy({left:-step()*1.2,behavior:'smooth'});});
  if(n)n.addEventListener('click',function(){scr.scrollBy({left:step()*1.2,behavior:'smooth'});});
 }
 // clip carousel: arrows + only play what's actually on screen
 var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 q('.hh-home .clip-rail').forEach(function(rail){
  var wrap=rail.closest('.clip-rail-wrap');
  var cstep=function(){var c=rail.querySelector('.clip');return c?c.getBoundingClientRect().width+10:170;};
  var cp=wrap&&wrap.querySelector('.clip-prev'),cn=wrap&&wrap.querySelector('.clip-next');
  if(cp)cp.addEventListener('click',function(){rail.scrollBy({left:-cstep()*2,behavior:'smooth'});});
  if(cn)cn.addEventListener('click',function(){rail.scrollBy({left:cstep()*2,behavior:'smooth'});});
  var vids=q('video[data-lazy-clip]',rail);
  var vio=new IntersectionObserver(function(es){
   es.forEach(function(e){
    var v=e.target;
    if(e.isIntersecting){
     if(!v.dataset.loaded){v.preload='auto';v.load();v.dataset.loaded='1';}
     if(!reduce){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}
    }else if(!v.paused){v.pause();}
   });
  },{threshold:.4});
  vids.forEach(function(v){vio.observe(v);});
 });

 // ---------------------------------------------------------------------------
 // BUNDLE (homepage copy). Rewritten 6 Sep 2026.
 //
 // Percentages live in snippets/hh-ladder.liquid (window.HH_LADDER) - the same
 // object the PDP bundle uses - so the two cards can never drift apart again.
 //
 // The old code wrote _flyBundles:* line properties because the Fly Bundles app
 // applied the discount server-side. Fly was demoted to a gift-only engine and
 // Grip-X was removed from its offer, so those properties now discount nothing:
 // verified 6 Sep with real carts, identical totals with and without them. The
 // discount today comes from native Shopify automatic discounts that key off
 // quantity alone, so we add plain line items.
 //
 // All maths in integer cents - Shopify floors the per-unit discount and naive
 // dollar arithmetic drifts, which is how the card ended up quoting $223 on a
 // cart that charged $228.
 // ---------------------------------------------------------------------------
 var b1=root.querySelector('.hh-home [data-b1]');
 if(b1 && window.HH_PRICE){
  var P=window.HH_PRICE;
  var stdHandle=b1.getAttribute('data-b1-std-handle')||'';
  var gripHandle=b1.getAttribute('data-b1-grip-handle')||'';
  var stdSel=b1.querySelector('[data-b1-std]');
  var gripSel=b1.querySelector('[data-b1-grip]');
  var nowEl=b1.querySelector('[data-b1-now]');
  var wasEl=b1.querySelector('[data-b1-was]');
  var saveEl=b1.querySelector('[data-b1-save]');
  var addBtn=b1.querySelector('[data-b1-add]');
  var tiers=q('[data-b1-tier]',b1);
  // data-price is money_without_currency, e.g. "34.97" -> 3497 cents
  function priceOf(sel){
   if(!sel||!sel.options.length)return 0;
   var v=parseFloat(sel.options[sel.selectedIndex].getAttribute('data-price'))||0;
   return Math.round(v*100);
  }
  function totals(n){
   var sp=priceOf(stdSel),gp=priceOf(gripSel);
   return {
    base:(sp+gp)*n,
    disc:P.unitAfter(sp,P.pctFor(stdHandle,n))*n + P.unitAfter(gp,P.pctFor(gripHandle,n))*n
   };
  }
  function qtyOf(t){return parseInt(t.getAttribute('data-qty'),10)||1;}
  function selectedTier(){
   for(var i=0;i<tiers.length;i++){var r=tiers[i].querySelector('.b1-tier-input');if(r&&r.checked)return tiers[i];}
   return tiers[0];
  }
  function pct(tt){return (tt.base>0)?Math.round((1-tt.disc/tt.base)*100):0;}
  function recalc(){
   // per-tier pricing, so the customer can compare all three at a glance
   tiers.forEach(function(t){
    var tt=totals(qtyOf(t)),p=pct(tt),saved=tt.base-tt.disc;
    var pe=t.querySelector('[data-b1-tier-price]'),se=t.querySelector('[data-b1-tier-save]'),oe=t.querySelector('[data-b1-tier-off]');
    if(pe)pe.textContent=P.money(tt.disc);
    if(se)se.textContent=saved>0?'Save '+P.money(saved):'';
    if(oe){oe.textContent=p>0?p+'% OFF':'';oe.style.display=p>0?'':'none';}
    var r=t.querySelector('.b1-tier-input');
    t.classList.toggle('is-selected',!!(r&&r.checked));
   });
   var sel=selectedTier(),t=totals(qtyOf(sel)),p=pct(t),saved=t.base-t.disc;
   if(nowEl)nowEl.textContent=P.money(t.disc);
   if(saved>0){
    if(wasEl)wasEl.textContent=P.money(t.base);
    if(saveEl)saveEl.textContent='You save '+P.money(saved)+' ('+p+'%)';
   }else{
    if(wasEl)wasEl.textContent='';
    if(saveEl)saveEl.textContent='';
   }
  }
  if(stdSel)stdSel.addEventListener('change',recalc);
  if(gripSel)gripSel.addEventListener('change',recalc);
  tiers.forEach(function(t){
   var r=t.querySelector('.b1-tier-input');
   if(r)r.addEventListener('change',recalc);
  });
  recalc();
  // one add routine, shared by the mobile footer button and the per-card
  // buttons that appear when the tiers lay out as three cards on desktop
  function addBundle(qty,btn){
    if(!stdSel||!gripSel||!stdSel.value||!gripSel.value)return;
    var label=btn.textContent;
    btn.disabled=true;btn.textContent='Adding…';
    var items=[
     {id:parseInt(stdSel.value,10),quantity:qty},
     {id:parseInt(gripSel.value,10),quantity:qty}
    ];
    // open the cart drawer instead of hard-navigating to /cart
    var cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
    var payload={items:items};
    if(cart&&typeof cart.getSectionsToRender==='function'){
     payload.sections=cart.getSectionsToRender().map(function(s){return s.id;});
     payload.sections_url=window.location.pathname;
    }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/javascript'},body:JSON.stringify(payload)})
     .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
     .then(function(data){
      btn.disabled=false;btn.textContent=label;
      if(cart&&typeof cart.renderContents==='function'){
       if(cart.classList.contains('is-empty')){cart.classList.remove('is-empty');}
       cart.renderContents(data);
      }
      else{window.location.href='/cart';}
     })
     .catch(function(){btn.disabled=false;btn.textContent=label;alert('Something went wrong adding to cart, please try again.');});
  }
  if(addBtn){
   addBtn.addEventListener('click',function(){addBundle(qtyOf(selectedTier()),addBtn);});
  }
 }
})();
  } catch(e) { console.error(e); }
})();

})();
